function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "a",
  width: "233.3%",
  height: "233.3%",
  x: "-66.7%",
  y: "-66.7%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 25
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0.482352941 0 0 0 0 1 0 0 0 0.3 0"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), React.createElement("linearGradient", {
  id: "b",
  x1: "75.45%",
  x2: "29.54%",
  y1: "76.401%",
  y2: "44.457%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#00AEFF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#0076FF"
})), React.createElement("linearGradient", {
  id: "c",
  x1: "79.179%",
  x2: "36.604%",
  y1: "74.229%",
  y2: "38.937%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#00AEFF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#0076FF"
})), React.createElement("linearGradient", {
  id: "d",
  x1: "88.751%",
  x2: "6.325%",
  y1: "49.912%",
  y2: "50.118%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#00AEFF",
  stopOpacity: 0.6
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#0076FF",
  stopOpacity: 0.3
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 46)"
}, React.createElement("g", {
  filter: "url(#a)",
  transform: "translate(131)"
}, React.createElement("path", {
  fill: "#007BFF",
  d: "M149.865 74.933c0 41.382-33.548 74.932-74.932 74.932C33.548 149.865 0 116.315 0 74.933 0 33.55 33.548 0 74.933 0c41.384 0 74.932 33.55 74.932 74.933"
}), React.createElement("path", {
  fill: "#4DA2FF",
  d: "M.6 65.604c22.23 3.161 59.602-12.715 71.583-15.039 24.354-4.726 49.37.9 74.19 1.724a74.556 74.556 0 0 0-6.888-15.398c-9.128.379-18.75-1.206-27.959-1.474-17.487-.508-34.874 4.085-52.333 3.029-8.07-.49-26.23-7.557-42.743-10.335A74.544 74.544 0 0 0 .6 65.604M74.933 0a74.822 74.822 0 0 0-21.88 3.257c9.386 5.358 28.201 7.28 32.567 7.865 7.85 1.052 16.376 1.428 23.113-2.73.093-.06.184-.127.278-.188A74.59 74.59 0 0 0 74.933 0M149.837 75.976c-21.59-5.454-44.444-5.896-66.204-1.143-11.822 2.58-23.27 6.64-35.018 9.539-14.772 3.641-30 5.402-45.21 5.285a50.417 50.417 0 0 1-1.96-.057c2.975 14.987 10.418 28.36 20.885 38.683a258.211 258.211 0 0 0 51.292-24.848c14.091-8.876 28.191-19.448 44.776-20.965 10.295-.942 20.413 1.743 30.606 3.85.516-3.379.787-6.835.833-10.344M145.87 99.067c-10.163-1.504-28.333 7.435-32.78 11.203-3.97 3.363-7.318 7.471-11.605 10.421-5.442 3.744-12.018 5.374-18.413 7.024A703.897 703.897 0 0 0 44.646 138.8c-1.613.513-3.361 1.222-4.148 2.678a74.576 74.576 0 0 0 34.435 8.387 74.816 74.816 0 0 0 24.789-4.217c7.776-11.1 12.421-25.485 24.728-30.702 2.08-.88 9.39-1.924 15.991-3.637a74.508 74.508 0 0 0 5.429-12.242"
})), React.createElement("path", {
  fill: "url(#b)",
  fillRule: "nonzero",
  d: "M28 106.75c-1.65 0-3-1.35-3-3V90.4c0-1.8 0-3 2.1-5.55L79 22.9c.45-.45.9-.9 2.25-.9h11.1c1.65 0 3 1.35 3 3v62.55h12.3c1.8 0 3 1.2 3 2.85v13.35c0 1.5-1.2 3-3 3h-12.3v18.75c0 1.65-1.35 3-2.85 3H76.15c-1.5 0-2.85-1.35-2.85-3v-18.75H28zm21.15-18.9v.3h24.3V58.9h-.3l-24 28.95z"
}), React.createElement("path", {
  fill: "url(#c)",
  fillRule: "nonzero",
  d: "M304 106.75c-1.65 0-3-1.35-3-3V90.4c0-1.8 0-3 2.1-5.55L355 22.9c.45-.45.9-.9 2.25-.9h11.1c1.65 0 3 1.35 3 3v62.55h12.3c1.8 0 3 1.2 3 2.85v13.35c0 1.5-1.2 3-3 3h-12.3v18.75c0 1.65-1.35 3-2.85 3h-16.35c-1.5 0-2.85-1.35-2.85-3v-18.75H304zm21.15-18.9v.3h24.3V58.9h-.3l-24 28.95z"
}), React.createElement("ellipse", {
  cx: 206,
  cy: 187,
  fill: "url(#d)",
  opacity: 0.372,
  rx: 206,
  ry: 10
}));

var Svg404 = function Svg404(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 412,
    height: 246,
    viewBox: "0 0 412 246",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404.1caee79b.svg";
export { ForwardRef as ReactComponent };